import linkDeviationStore from './store'

export default class LinkDeviationModule {
  name = 'linkDeviation'
  constructor({ store }) {
    store.registerModule(this.name, linkDeviationStore)
  }
}
